import { useState, useCallback, useEffect } from "react";

export function usePackageSelection({
  defaultPackages,
}: {
  defaultPackages?: { value: string; label: string }[];
}) {
  const [packages, setPackages] = useState<{ value: string; label: string }[]>(
    defaultPackages ?? [],
  );
  const [filteredPackages, setFilteredPackages] = useState<
    { value: string; label: string }[]
  >(defaultPackages ?? []);

  const [selectedPackage, setSelectedPackage] = useState<{
    value: string;
    label: string;
  } | null>(null);

  useEffect(() => {
    setFilteredPackages(packages);
  }, [packages]);

  const handleSearchPackages = useCallback(async (term: string) => {
    const filteredPackages = packages.filter((packageItem) =>
      packageItem.label.toLowerCase().includes(term.toLowerCase()),
    );

    setFilteredPackages(
      filteredPackages.map((packageItem) => ({
        value: packageItem.value,
        label: packageItem.label,
      })),
    );
  }, []);

  const handlePackageSelect = useCallback(async (packageId: string) => {
    const companyPackage = packages.find(
      (packageItem) => packageItem.value === packageId,
    );
    if (companyPackage) {
      setSelectedPackage(companyPackage);
    }
  }, []);

  return {
    packages,
    filteredPackages,
    selectedPackage,
    setPackages,
    handleSearchPackages,
    handlePackageSelect,
  };
}
